<script setup lang="ts">
import type { Avatar } from '#ui/types'

// Define the team type using NuxtUI Avatar type
interface Team {
  label: string
  avatar: Avatar
}

const team: Team = {
  label: 'SRXplorer',
  avatar: {
    src: '/favicon.svg'
  }
}
</script>

<template>
  <div class="flex items-center gap-2">
    <UAvatar :src="team.avatar.src" size="sm" />
    <span class="truncate text-gray-900 dark:text-white font-semibold">{{ team.label }}</span>
  </div>
</template>
